package com.shadowings.gero.data.lessons.chapter9

import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_facciamo_il_punto_1
import gero.composeapp.generated.resources.exp_content_facciamo_il_punto_2
import gero.composeapp.generated.resources.exp_content_facciamo_il_punto_3
import gero.composeapp.generated.resources.exp_content_facciamo_il_punto_4
import gero.composeapp.generated.resources.exp_content_facciamo_il_punto_5
import gero.composeapp.generated.resources.exp_content_facciamo_il_punto_6
import gero.composeapp.generated.resources.exp_content_facciamo_il_punto_7
import gero.composeapp.generated.resources.exp_content_facciamo_il_punto_8
import gero.composeapp.generated.resources.exp_content_facciamo_il_punto_9
import gero.composeapp.generated.resources.exp_content_facciamo_il_punto_10
import gero.composeapp.generated.resources.exp_title_facciamo_il_punto

fun getFacciamoIlPuntoContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_facciamo_il_punto,
            content = Res.string.exp_content_facciamo_il_punto_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_facciamo_il_punto,
            content = Res.string.exp_content_facciamo_il_punto_2,
            face = Faces.Serious,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_facciamo_il_punto,
            content = Res.string.exp_content_facciamo_il_punto_3,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_facciamo_il_punto,
            content = Res.string.exp_content_facciamo_il_punto_4,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_facciamo_il_punto,
            content = Res.string.exp_content_facciamo_il_punto_5,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_facciamo_il_punto,
            content = Res.string.exp_content_facciamo_il_punto_6,
            face = Faces.Surprised,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_facciamo_il_punto,
            content = Res.string.exp_content_facciamo_il_punto_7,
            face = Faces.Sad,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_facciamo_il_punto,
            content = Res.string.exp_content_facciamo_il_punto_8,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_facciamo_il_punto,
            content = Res.string.exp_content_facciamo_il_punto_9,
            face = Faces.Surprised,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_facciamo_il_punto,
            content = Res.string.exp_content_facciamo_il_punto_10,
            face = Faces.Happy,
            character = Characters.Nilo,
        )
    )
}

fun getFacciamoIlPuntoQuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String,
    adverbialSentencesTsvContent: String? = null
): List<IQuizContent> {
    val qIw = getParticleIwQuizContent().shuffled().take(1)
    val qAvverbiali = getFrasiAvverbialiQuizContent().shuffled().take(1)
    val qHiero1 = getHieroVari1QuizContent(hiero, words, languageCode).shuffled().take(1)
    val qVocab1 = getVocabVari1QuizContent(getVocabVari1Content(words, languageCode), words, languageCode).shuffled().take(1)
    val qHiero2 = getHieroVari2QuizContent(hiero, words, languageCode).shuffled().take(1)
    val qVocab2 = getVocabVari2QuizContent(getVocabVari2Content(words, languageCode), words, languageCode).shuffled().take(1)
    val qPrepM = getPreposizioneMQuizContent(hiero, words, languageCode).shuffled().take(1)
    val qTutto = getTuttoInsiemeOraQuizContent(words, languageCode, adverbialSentencesTsvContent).shuffled().take(3)

    val combined = qIw + qAvverbiali + qHiero1 + qVocab1 + qHiero2 + qVocab2 + qPrepM + qTutto
    return combined.shuffled()
}
